// @flow
import * as React from 'react'
import styled from 'styled-components'
import Theme from 'ui/theme'

type Props = {
  /** Whether to show a border around the card */
  border?: boolean,
  /** The content of the card */
  children: React.Node,
  /** Whether to remove padding from the card */
  $noPadding?: boolean,
  /** Whether to make the card full height */
  $fullHeight?: boolean,
  /** The width of the card */
  width?: string,
}

const StyledFlatCard: React.ComponentType<Props> = styled.div`
  width: ${(props: Props) => props.width || 'initial'};

  ${({ border }: Props) =>
    border &&
    `
    border-width: ${Theme.width.border};
    border-style: solid;
    border-radius: ${Theme.spacing.xsmall};
    border-color: ${Theme.color.borderSecondary};
  `}

  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  background-color: #ffffff;

  ${({ $noPadding }: Props) =>
    $noPadding &&
    `
    padding: 0;
  `}

  ${(props: Props) => {
    if (props.$fullHeight) {
      return `
        height: 100%;
      `
    }
    return ''
  }}
`

/** A flat card component with white background and padding */
const FlatCard = ({ children, ...props }: Props): React.Node => (
  <StyledFlatCard {...props}>{children}</StyledFlatCard>
)

export default FlatCard
